import { render, staticRenderFns } from "./DropdownComponent.vue?vue&type=template&id=2d18b4c9&scoped=true&"
import script from "./DropdownComponent.vue?vue&type=script&lang=ts&"
export * from "./DropdownComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownComponent.vue?vue&type=style&index=0&id=2d18b4c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d18b4c9",
  null
  
)

export default component.exports